import { useGetSettingEnableSDUIWebCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingEnableSDUIWebCategoryPage";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { useIsSDUISeasonalHubPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsSDUISeasonalHubPage";
export var useShouldEnableSDUIProductFirstPage = function() {
    var isProductFirstCategory = useShowProductFirstResults();
    var shouldEnableSDUIWebCategoryPage = useGetSettingEnableSDUIWebCategoryPage();
    var isSDUISeasonalHubPage = useIsSDUISeasonalHubPage();
    var isEligibleForSDUIProductFirstPage = isProductFirstCategory && !isSDUISeasonalHubPage;
    return {
        isEligibleForSDUIProductFirstPage: isEligibleForSDUIProductFirstPage,
        shouldEnableSDUIProductFirstPage: isEligibleForSDUIProductFirstPage && shouldEnableSDUIWebCategoryPage
    };
};
